const typesTagList = [
  { label: "Tickets", value: "TICKETS" },
  { label: "Recommendations", value: "RECOMMENDATIONS" },
  { label: "Rec. & Tickets", value: "BOTH" },
  { label: "Jobs", value: "JOBS" },
];

export default typesTagList;
